import moment from 'moment';
import OrderSearchOptions from "../models/OrderSearchOptions";

const SEARCH_OPTIONS_SCHEMA: OrderSearchOptions = {
  startDate: moment(),
  endDate: moment(),
  startTime: '',
  endTime: '',
  keyword: '',
  currDate: false,
  errorKeyword: false
};

export {
  SEARCH_OPTIONS_SCHEMA
}